/** Created by azhou on 2018/11/30.*/
<template>
  <div id="e-line"></div>
</template>

<script>
  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts')
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title')
  export default {
    data () {
      return {}
    },
    props: {
      DataSet: {     //数据集合
        type: Array,
        default () {
          return []
        }
      },
      xAxisSet: {     //X轴数据集合
        type: Array,
        default () {
          return []
        }
      },
      chartTitle: {
        type: String,
        default: '金额统计数据132456'
      },
    },
    watch: {
      DataSet () {
        this.initEchart()
      }
    },
    mounted () {
      $('#e-line').css({
        height: $('.e-data').height() * 0.6 + 'px',
      })
      this.initEchart()
    },
    methods: {
      /*初始化echart图表*/
      initEchart () {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init($('#e-line').get(0))
        let option = {
          title: {
            text: this.chartTitle,
            left: 'center',
            textStyle: {
              color: '#eee',
              fontSize: '16px',
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          toolbox: {
            show: true,
            right: '40px',
            feature: {
              restore: { show: true },
              dataZoom: { show: true },
              magicType: { type: ['line', 'bar'] }
            }
          },
          legend: {
            orient: 'horizontal',
            top: 'top',
            left: 'left',
            data: this.DataSet.map(item => item.name),
            textStyle: { color: '#eee' }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#919191'
              }
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: '#919191'
              }
            },
            axisLabel: {
              fontSize: 12,
              color: '#919191'
            },
            data: this.xAxisSet
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              fontSize: 12,
              color: '#919191'
            },
            axisLine: {
              lineStyle: {
                color: '#919191'
              }
            },
          },
          series: this.DataSet
        }
        // 绘制图表
        myChart.setOption(option)
      },
    }
  }
</script>
